<script setup lang="ts">
import { TransitionPresets, useTransition } from '@vueuse/core'

interface IProps {
  currentValue: number
  currencyId: number
}

const props = defineProps<IProps>()

// Count up from zero once mounted, so SSR and hydration both render the initial zero
const isMounted = ref(false)
onMounted(() => (isMounted.value = true))

const rate = useTransition(() => (isMounted.value ? props.currentValue : 0), {
  duration: 500,
  easing: TransitionPresets.easeOutQuad
})

const finalLength = computed(
  () => useCurrencyFormat(props.currentValue, props.currencyId, false)?.length ?? 0
)
</script>

<template>
  <!-- Width is reserved for the final value (tabular digits are 1ch wide),
       so the count-up does not shift the neighbouring rates -->
  <strong class="tabular-nums" :style="{ minWidth: `${finalLength}ch` }">
    {{ useCurrencyFormat(rate, currencyId, false) }}
  </strong>
</template>
